<script>
   import Ferry from "./RadarFerry.svelte";

   let dist1 = 5
   let dist2 = 10 
   let dist3 = 15
   let bg_color = "white"

   export let boats = []
</script>

<div>
   <svg width=100% height=100% viewBox="0 0 200 200" style="background-color:{bg_color}">
      <circle cx="100" cy="100" r="5"/>
      <circle cx="100" cy="100" r="30" fill="none" stroke="black" stroke-width="0.5"/>
      <circle cx="100" cy="100" r="60" fill="none" stroke="black" stroke-width="0.5"/>
      <circle cx="100" cy="100" r="90" fill="none" stroke="black" stroke-width="0.5"/>

      <rect width="14" height="7" x="93" y="66" fill="{bg_color}"/>
      <text x="93" y="72" font-size="7">5km</text>
      <rect width="17" height="7" x="93" y="36" fill="{bg_color}"/>
      <text x="93" y="42" font-size="7">10km</text>
      <rect width="17" height="7" x="93" y="6" fill="{bg_color}"/>
      <text x="93" y="12" font-size="7">15km</text>

      {#each boats as b}
         <Ferry boat={b}/>
      {/each}
         
   </svg>
</div>
